module.exports = __webpack_public_path__ + "img/developerstudent.b5e37037.png";